import React from 'react'
import { TextField, Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { escapeRegExp } from 'lodash'

export const SearchBar = (props) => {
  const { setKey } = props

  const navigate = useNavigate()

  const handleSearch = (event) => {
    const value = event.target.value?.trim() || ''
    try {
      // Is the value a valid regex pattern?
      new RegExp(value)
      setKey(value)
    } catch (e) {
      // If not, escape
      setKey(escapeRegExp(value))
    }
    navigate(`/claims-review`)
  }
  return (
    <Box display='flex' flexDirection='column'>
      <TextField label='Search' variant='outlined' onChange={handleSearch} />
    </Box>
  )
}
